"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Attribution;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _text = _interopRequireDefault(require("@ux/text"));
const FigCaption = /*#__PURE__*/(0, _react2.styled)(_text.default.figcaption)({
  name: "FigCaption",
  class: "pl-f17ge76",
  vars: {
    "f17ge76-0": [({
      position
    }) => position === 'top-left' || position === 'bottom-left' ? 'start' : 'end'],
    "f17ge76-1": [({
      position
    }) => position === 'top-left' || position === 'bottom-left' ? '0' : 'unset'],
    "f17ge76-2": [({
      position
    }) => position === 'top-right' || position === 'bottom-right' ? '0' : 'unset'],
    "f17ge76-3": [({
      position
    }) => position === 'bottom-left' || position === 'bottom-right' ? '0' : 'unset'],
    "f17ge76-4": [({
      position
    }) => position === 'top-left' || position === 'bottom-left' ? 'end' : 'start'],
    "f17ge76-5": [({
      position
    }) => position === 'top-left' || position === 'bottom-left' ? 'unset' : '0'],
    "f17ge76-6": [({
      position
    }) => position === 'top-right' || position === 'bottom-right' ? 'unset' : '0']
  }
});

/**
 * Render Attribution
 *
 * @param {Object} props React props
 * @param {string} props.attribution Raw attribution text
 * @param {string} props.attributionPosition Attribution position
 * @returns {React.ReactElement} Attribution
 * @public
 */
function Attribution({
  attribution,
  attributionPosition = 'top-left'
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(FigCaption, {
    size: -1,
    position: attributionPosition,
    "data-cy": "attribution"
  }, (0, _patternLibraryUtils.formatAttribution)(attribution, true)));
}
Attribution.propTypes = {
  attribution: _propTypes.default.string.isRequired,
  attributionPosition: _propTypes.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']).isRequired
};